import { useCallback } from 'react';
import type { HeadlineSmallOneLineProps } from './types';
import { Headline, HeadlineRightPanel } from '@banhala/ui-kit';
import {
  bridge,
  convertDeeplinkToWebLink,
  getWebBaseURL,
  isNil,
} from '../../../../utils';
import { ABLY_INFO } from '../../../../constant/ablyInfo';
import type { IScreensLogging } from '../../../../api/types';
import { ViewAllButton } from '../ViewAllButton';

export const HeadlineSmallOneLine = ({ header }: HeadlineSmallOneLineProps) => {
  const handleClickViewAllButton = useCallback(() => {
    if (isNil(header)) return;
    const { deeplink } = header.item;
    if (isNil(deeplink)) return;

    logClickViewAllButton({ logging: header.logging });

    bridge.openDeeplink(deeplink, {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        const convertedLink = convertDeeplinkToWebLink(deeplink);
        if (convertedLink === ABLY_INFO.url) {
          location.href = ABLY_INFO.url;
          return;
        }
        location.href = `${baseURL}${convertedLink}`;
      },
    });
  }, [header]);

  if (isNil(header)) {
    return null;
  }
  const isRoutable = header.item.deeplink !== null;

  return (
    <>
      <Headline
        size="medium"
        headline={header.item.title}
        testID={header.item.title}
        rightPanel={
          <>
            {isRoutable && (
              <HeadlineRightPanel type={'textButton'}>
                <ViewAllButton
                  onPress={handleClickViewAllButton}
                  padding={{ right: 4 }}
                />
              </HeadlineRightPanel>
            )}
          </>
        }
      />
    </>
  );
};

const logClickViewAllButton = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_ONE_LINE_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
